<template>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="controls/as-widget-container"></require>

  <div class="as-widget-stack">
    <div class="as-widget-stack__show-new-item-widget-button" show.bind="!disabled && !newItemWidgetVisible">
      <button type="button" class="btn btn-icon text-primary" click.delegate="showNewItemWidget()" disabled.bind="disabled">
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div show.bind="!disabled && newItemWidgetVisible">
      <div class="as-widget-stack__item as-widget-stack__new-item li-${kind}">
        <div class="as-widget-stack__item-main">
          <as-widget-container kind.bind="kind" model.bind="newItem"></as-widget-container>
        </div>
        <div class="as-widget-stack__item-controls">
          <div class="fa-lg fa-fw"></div>
          <div class="btn-group-vertical btn-group-sm">
            <button type="button" class="btn btn-icon text-primary" title="Add" click.delegate="addNewItemInternal()">
              <i class="fas fa-check"></i>
            </button>
            <button type="button" class="btn btn-icon text-danger" title="Cancel" click.delegate="cancelAddNewItem()">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="as-widget-stack__item li-${kind}" repeat.for="item of items">
      <div class="as-widget-stack__item-main">
        <as-widget-container kind.bind="kind" model.bind="item" disabled.bind="true" index.bind="$index"></as-widget-container>
      </div>
      <div class="as-widget-stack__item-controls" show.bind="!disabled">
        <div class="fa-lg fa-fw"></div>
        <div class="btn-group-vertical btn-group-sm">
          <button type="button" class="btn btn-icon text-danger" click.delegate="removeItemInternal(item)">
            <i class="fas fa-times" title="Remove"></i>
          </button>
          <button if.bind="widgetButtons == null" type="button" class="btn btn-icon text-secondary" style="visibility: hidden;">
            <i class="fas fa-times"></i>
          </button>
          <button type="button" class="btn btn-icon text-primary" repeat.for="widgetButton of widgetButtons" click.delegate="widgetButton.onClick(item)">
            <i class="fas ${widgetButton.icon}" title="${widgetButton.title}"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
